import React from 'react'
import { View } from 'react-native'
import tw from 'tailwind-rn'

import {
  BlockType,
  BlockImageGalleryType,
  BlockMenuType,
  BlockMarkdownType,
  BlockStateDistrictsType,
  BlockChildrenOverviewType,
} from '../../config/types'
// import styles from './styles'
import BlockMarkdown from './BlockMarkdown'
import BlockImageGallery from './BlockImageGallery'
import BlockMenu from './BlockMenu'
import BlockStateDistricts from './BlockStateDistricts'
import BlockSuspicionChecker from './BlockSuspicionChecker'
import BlockChildrenOverview from './BlockChildrenOverview'

type Props = {
  blocks: null | {
    id: string
    item: BlockType // TODO: move Blocktype out of object
  }
}

export const mapMenuItems = (result: unknown) => {
  return (
    result.nodes
      // If menu point is not available, skip it
      .filter((n) => n.item !== null)
      .map((n: unknown) => {
        const {
          id,
          item: {
            id: menuItemId,
            url,
            title,
            description,
            slug,
            type,
            location_types: locationTypes,
            is_downloadable: isDownloadable,
          },
        } = n

        const item = {
          id,
          type,
          title,
          description,
          isDownloadable,
          slug,
        }
        if (type === 'resource') item.resourceId = menuItemId
        if (type === 'external-url') item.url = url
        if (type === 'locations') item.locationType = locationTypes

        return item
      })
  )
}

/**
 * This components displays content blocks dynamically. It has a loading animation.
 */
const BlockGrid = (props: Props) => {
  const { blocks } = props

  if (blocks === null)
    return (
      <>
        <View style={tw('rounded h-20 mb-3 bg-gray-200')} />
        <View style={tw('rounded h-20 mb-3 bg-gray-200')} />
        <View style={tw('rounded h-40 mb-3 bg-gray-200')} />
      </>
    )

  return (
    <View>
      {blocks
        .filter((b) => b?.item !== null)
        .map((b: { id: string; item: BlockType }) => {
          const {
            id: blockId,
            item: { type },
          } = b
          let data = null

          if (type === 'markdown') {
            data = b.item as BlockMarkdownType
            return <BlockMarkdown data={data} key={blockId} />
          }

          if (type === 'image-gallery') {
            data = b.item as BlockImageGalleryType

            return <BlockImageGallery data={data} key={blockId} />
          }

          if (type === 'menu') {
            data = {
              items: mapMenuItems(b.item),
            } as BlockMenuType
            return <BlockMenu data={data} key={blockId} />
          }

          if (type === 'state-districts') {
            data = {
              state: b.item?.state,
              locationTypes: b.item?.location_types,
            } as BlockStateDistrictsType

            return <BlockStateDistricts data={data} key={blockId} />
          }

          if (type === 'suspicion-checker') {
            return <BlockSuspicionChecker key={blockId} />
          }

          if (type === 'children-overview') {
            data = b.item as BlockChildrenOverviewType

            return <BlockChildrenOverview data={data} key={blockId} />
          }
        })}
    </View>
  )
}

export default BlockGrid
